import { stringify } from "query-string";
import { Redirect } from "react-router-dom";
export function hydrateRoute(routePath, params) {
    const withoutLocale = (routePath || "").replace(/^\/:locale\(.+?\)\?/, "");
    const hydrated = withoutLocale.replace(/:[a-zA-Z]+(\(.+?\))?\??\*?/gi, (part) => {
        const paramName = part.slice(1).replace(/\(.*?\)\??\*?|\?|\*/, "");
        const defaultValue = part.match(/\?$/) ? "" : part;
        return params[paramName] !== undefined ? params[paramName] : defaultValue;
    });

    return params.locale && hydrated.match(/^\//) ? `/${params.locale}${hydrated}` : hydrated;
}

function injectFilters(path, queryParams) {
    if ((queryParams && !queryParams.filter) || !queryParams) {
        return path;
    }
    return `${path}?${stringify({ filter: queryParams.filter })}`;
}

export function createLink(basePath, proxy, item, params, queryParams) {
    if (!((item && item.id && `${item.id}`.length) || (item && item.to && `${item.to}`.length))) {
        return null;
    }
    if (basePath) {
        return injectFilters(`${hydrateRoute(basePath, { ...params })}/${item.id}`, queryParams);
    }
    if (item.to) {
        return injectFilters(hydrateRoute(item.to, { ...params }), queryParams);
    }
    const proxyPath = (proxy || {})[item["__typename"]];
    return injectFilters(hydrateRoute(proxyPath, { ...params, id: item.id }), queryParams);
}

export const deepLink = (links, path, setSelectedLink) => {
    const linksFlattened = flattenNestedLinks(links);
    const candidateLinks = linksFlattened.filter((link) => path.startsWith(link.to));
    const [selectedLink] = candidateLinks.sort((a, b) => b.to.length - a.to.length);
    if (selectedLink?.id) {
        setSelectedLink(selectedLink.id);
    } else {
        setSelectedLink("");
    }
};

function flattenNestedLinks(linksOriginal) {
    if (linksOriginal && linksOriginal.length > 0) {
        return linksOriginal.reduce((acc, link) => {
            Array.isArray(link.nestedLinks)
                ? acc.push(...flattenNestedLinks(link.nestedLinks))
                : acc.push(link);
            return acc;
        }, []);
    }

    return [];
}

export function urlRedirectLink(linkToRedirect, isToForcePush = false) {
    return isToForcePush ? (
        <Redirect to={`${linkToRedirect}`} push />
    ) : (
        <Redirect to={`${linkToRedirect}`} />
    );
}
